module.exports = __webpack_public_path__ + "static/img/banner.ef3cd92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = omhf
// module chunks = 1